export default {"src":"/_next/static/media/start-icon.a66dee72.svg","height":42,"width":35};